import React from "react";
import { cj } from "../../../../utils/cls";
import styles from "../../../../components/Table/index.modules.less";
import IntlTableItem from "./tableItem";

const IntlTable = ({ data = {}, tabkey }) => {
  let { list = [] } = data;

  if (tabkey != 911) {
    list = list.filter((item) => item.app_status_id == tabkey);
  }

  return (
    <div className={styles.normal_list}>
      <div className={cj(styles.l_header)}>
        <div className={styles.l_name}>名称</div>
        <div className={styles.l_type}>类型</div>
        <div className={styles.l_version}>版本</div>
        <div className={styles.l_time}>提交时间</div>
        <div className={styles.l_state}>状态</div>
        <div className={styles.l_state}>备注</div>
        <div className={styles.l_btn}>操作</div>
      </div>
      {list?.map((item, index) => (
        <IntlTableItem tabkey={tabkey} key={item.id || index} data={item} index={index} />
      ))}
    </div>
  );
};

export default IntlTable;
